import React, { useState } from 'react';
import { Popover, useMediaQuery } from '@mui/material';
import {
  StyledAccountIconButton,
  AvatarIcon,
  SmallAvatarIcon,
  StyledMenuItem,
} from 'src/components/Layout/NavbarStyles';
import UserProfile from 'src/Images/Profile.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from 'src/redux/Actions/Auth';

function AccountPopover() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:767px)');
  const [open, setOpen] = useState(null);
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };
  const LogoutUser = () => {
    dispatch(logout());
    setOpen(null);
    navigate('/login');
  };
  const authReducer = useSelector((state) => state.AuthReducer);

  const settingsReducer = useSelector((state) => state.SettingsReducer);

  const { profileImage } = settingsReducer;

  return (
    <div className="avatar-padding">
      <StyledAccountIconButton
        onClick={handleOpen}
        className={
          open ? 'account-pop-over-icon' : 'account-pop-over-icon-button'
        }
      >
        <SmallAvatarIcon
          src={profileImage || UserProfile}
          alt="photoURL"
          id="accountIcon"
        />
      </StyledAccountIconButton>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: isMobile ? 'top' : 'top',
          horizontal: isMobile ? 'center' : 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        }}
        PaperProps={{
          sx: {
            mt: isMobile ? '-30px' : '30px',
          },
        }}
      >
        <StyledMenuItem
          className="popover-menu-item div-flex-column gap-1"
          disableRipple
        >
          <AvatarIcon
            src={profileImage || UserProfile}
            alt="photoURL"
            id="accountIcon"
          />
          <div className="popover-user-data div-flex-column div-align-center">
            <div className="popover-welcome text-bold text-lg">
              Welcome {authReducer?.userData?.name}!
            </div>
            <div className="popover-email-phone text-sm">
              {authReducer?.userData?.email}
            </div>
          </div>
          <button className="popover-logout text-grey" onClick={LogoutUser}>
            Logout
          </button>
        </StyledMenuItem>
      </Popover>
    </div>
  );
}

export default AccountPopover;
